import React from 'react';

export default function RoTabs({ activeTab, setActiveTab, partsCount, estimatesCount, onOpenEstimate }) {
  return (
    <div className="ro-tabs">
      <button
        className={`ro-tab${activeTab === 'activity' ? ' ro-tab--active' : ''}`}
        onClick={() => setActiveTab('activity')}
      >
        Activity
      </button>
      <button
        className={`ro-tab${activeTab === 'parts' ? ' ro-tab--active' : ''}`}
        onClick={() => setActiveTab('parts')}
      >
        Parts{partsCount ? ` (${partsCount})` : ''}
      </button>
      <button
        className={`ro-tab${activeTab === 'time' ? ' ro-tab--active' : ''}`}
        onClick={() => setActiveTab('time')}
      >
        Time
      </button>
      <button className="ro-tab" onClick={onOpenEstimate}>
        Estimate{estimatesCount ? ` (${estimatesCount})` : ''}
      </button>
    </div>
  );
}
